import type { FullNewsContactFragment } from '@dreamstack/investors-graphql'
import type { FunctionComponent } from 'react'
import 'twin.macro'
import { HeadingH3 } from '../index'

export const NewsArticleContact: FunctionComponent<React.PropsWithChildren<{
  contact: FullNewsContactFragment
}>> = ({ contact }) => {
  const { title, fullName, company, email, postcode, telefon, street } = contact

  return (
    <div tw="mb-px-64">
      <HeadingH3>{title}</HeadingH3>
      <div tw="mt-px-24">
        <p>{fullName}</p>
        <p>{company}</p>
        <p>{street}</p>
        <p>{postcode}</p>
      </div>
      <div tw="flex space-x-px-24 mt-px-24">
        <div>
          <p>E-Mail</p>
          <p>Telefon</p>
        </div>
        <div>
          <p>{email}</p>
          <p>{telefon}</p>
        </div>
      </div>
    </div>
  )
}
